(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/animations/assets/javascripts/animations/tweens/create-to-center-tween.js') >= 0) return;  svs.modules.push('/components/onboarding/animations/assets/javascripts/animations/tweens/create-to-center-tween.js');
"use strict";



const positions = svs.components.onboarding.slides.animations.positions;

const createToCenterTween = (el, duration) => gsap.to(el, {
  x: positions.center,
  duration
});
setGlobal('svs.components.onboarding.animations.tweens.createToCenterTween', createToCenterTween);

 })(window);